import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { AutoCompleteZipcode } from "@core/interfaces/api-responses/autocomplete-zipcode";

@Component({
    selector: "app-county-selection-modal",
    templateUrl: "./county-selection-modal.component.html",
    styleUrls: ["./county-selection-modal.component.scss"],
    standalone: false,
})
export class CountySelectionModalComponent implements OnDestroy {
    @Input() counties: AutoCompleteZipcode[] = [];
    @Output() selectionMade = new EventEmitter<AutoCompleteZipcode>();

    countyForm: UntypedFormGroup;
    public readonly translationPrefix = "common.modals.countyModal";

    private readonly historyState = { countyModal: true };
    private readonly onPopState = (): void => {
        history.pushState(this.historyState, "");
    };

    constructor(
        public activeModal: NgbActiveModal,
        private fb: UntypedFormBuilder,
    ) {
        this.countyForm = this.fb.group({
            county: [null, Validators.required],
        });
        history.pushState(this.historyState, "");
        window.addEventListener("popstate", this.onPopState);
    }

    ngOnDestroy(): void {
        this.teardownHistoryTrap();
    }

    emitSelectionMade() {
        const selectedCounty = this.countyForm.get("county").value;
        const county = this.counties.find((item) => item.county === selectedCounty);
        if (!county) {
            return;
        }
        this.teardownHistoryTrap();
        this.selectionMade.emit(county);
        this.activeModal.close("done");
    }

    private teardownHistoryTrap(): void {
        window.removeEventListener("popstate", this.onPopState);
        if (history.state?.countyModal) {
            history.back();
        }
    }
}
